const audienceGroups = [
  {
    id: "aud_all",
    name: "All IBOs",
    category: "general",
    description: "Default audience containing every IBO.",
    iboCount: 12480,
    rules: [{ field: "status", op: "eq", value: "active" }],
  },
  {
    id: "aud_pin_gold",
    name: "Gold & above",
    category: "general",
    description: "IBOs at Gold pin level or higher.",
    iboCount: 842,
    rules: [
      { field: "pinLevel", op: "in", value: ["Gold", "Platinum", "Diamond"] },
    ],
  },
  {
    id: "aud_us_only",
    name: "US only",
    category: "general",
    description: "IBOs based in the United States.",
    iboCount: 7100,
    rules: [{ field: "country", op: "eq", value: "US" }],
  },
  {
    id: "aud_fr_duncan_2024",
    name: "Duncan Family Reunion (2024)",
    category: "family_reunion",
    description: "LOS attendees of the 2024 Duncan Family Reunion.",
    iboCount: 1820,
    rules: [],
  },
  {
    id: "aud_fr_puryear_2024",
    name: "Puryear Family Reunion (2024)",
    category: "family_reunion",
    description: "LOS attendees of the 2024 Puryear Family Reunion.",
    iboCount: 940,
    rules: [],
  },
  {
    id: "aud_fr_baker_2024",
    name: "Baker Family Reunion (2024)",
    category: "family_reunion",
    description: "LOS attendees of the 2024 Baker Family Reunion.",
    iboCount: 760,
    rules: [],
  },
  {
    id: "aud_dia_tsika_p",
    name: "Tsika P",
    category: "diamond",
    description: "Tsika P LOS.",
    iboCount: 540,
    rules: [],
  },
  {
    id: "aud_dia_puryear_j",
    name: "Puryear J",
    category: "diamond",
    description: "Puryear J LOS.",
    iboCount: 612,
    rules: [],
  },
  {
    id: "aud_dia_yuen_d",
    name: "Yuen D",
    category: "diamond",
    description: "Yuen D LOS.",
    iboCount: 421,
    rules: [],
  },
  {
    id: "aud_dia_harimoto_s",
    name: "Harimoto S",
    category: "diamond",
    description: "Harimoto S LOS.",
    iboCount: 380,
    rules: [],
  },
];

export default audienceGroups;
